import type { FunctionTestWidgetConfig } from '../function-test.model';

export const FUNCTION_TEST_SINE_PRESET: FunctionTestWidgetConfig = {
  id: 'function-test-sine',
  type: 'function-test',
  params: {
    curve: {
      type: 'expression',
      expression: 'sin(x)',
    },
  },
  display: {},
};
